import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

interface EnterpriseSummaryTableProps {
  totalEnterprises: number;
}

export const EnterpriseSummaryTable = ({ 
  totalEnterprises, 
}: EnterpriseSummaryTableProps) => {
  return (
    <Box sx={{ flex: 1 }}>
      <TableContainer>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>구분</TableCell>
              <TableCell>개수</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>전체 기업</TableCell>
              <TableCell>{totalEnterprises}개</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}; 